import { DefaultApiResp } from '@root/globalTypes';
import { queryFetch } from '../api';
import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';
import { useJobRefetch } from '@hooks/job/refetch';
import { TaskReq } from '@services/jobs/tasks/types';

export const useCompleteTask = () => {
  const { refetch, stages } = useJobRefetch();
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ id }: TaskReq): Promise<DefaultApiResp> =>
      queryFetch({ url: `tasks/${id}/complete`, opt: { method: 'PUT' } }),
    onMutate: async ({ id, jobId }) =>
      stages.update({ jobId, task: { id, forceCompleted: true, status: 'completed' } }),
    onError: (err, { jobId }, prev) => {
      console.error(err);
      stages.restore(jobId, prev);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      const { errors } = data as DefaultApiResp;
      if (errors) showErrorToast(errors);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
